import { QueryClient } from '@tanstack/solid-query'
import { seedServerNowMs } from './params'

export const queryClient = new QueryClient()

// Seed the `['timestamp']` query with the server time supplied by native via
// the `ts` URL param. Every consumer of useTimestamp sees this value until
// the first `/time.js?` refetch lands (60s cadence). We only seed when the
// param was valid — a missing/bad `ts` leaves the cache empty so callers
// can detect "not anchored yet".
if (seedServerNowMs > 0) {
  queryClient.setQueryData(['timestamp'], seedServerNowMs)
}
